import { Box } from "@mui/material";
import EtDatePicker from "mui-ethiopian-datepicker";
import React, { SetStateAction } from "react";

interface YearRangeProps {
  startDate: Date,
  setStartDate: React.Dispatch<SetStateAction<Date>>,
  endDate: Date,
  setEndDate: React.Dispatch<SetStateAction<Date>>
}
const YearRangeFilterToolbarAction = ({startDate, endDate, setStartDate, setEndDate}: YearRangeProps): JSX.Element => {
  return (
    <Box display={"flex"} gap={2} alignItems={"center"}>
<EtDatePicker
            label={'From'}
                value={startDate as any}
                onChange={(newValue:any) => {
                  setStartDate(newValue);
                }}
              />
    <EtDatePicker
        label={'To'}
        value={endDate as any}
        onChange={(newValue:any) => {
          setEndDate(newValue);
        }}
    />
    </Box>
  );
};

export default YearRangeFilterToolbarAction;
